import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
// import VueRecaptcha from 'vue-recaptcha';
import VueJwtDecode from 'vue-jwt-decode';
import keycloak from '../../../keycloack';

export default {
  name: 'login',
  components: {
    VueElementLoading,
    // VueRecaptcha
  },
  props: [],
  data() {
    return {
      // form: {
      //   robot: false
      // },
      username: '',
      password: '',
      isLoading: false,
      isSSOLoading: false,
      tokenid: '',
      issumbit: '',
      eyeslash: true,
      eye: false,
      btndis: true,
      loginfailed:false,
      loginfailedmsg:"",
      apiurl:""
    }
  },
  computed: {

  },

  mounted() {
    this.apiurl = (process.env.NODE_ENV==='production')? 'http://userauthentication.xbees.in/#/forgotpassword':'http://stageusermanagement.xbees.in/#/forgotpassword'
    if (this.$route.params.id == undefined) {} else {
      this.tokenid = this.$route.params.id;
      // this.ssologin();
    }
    this.checklogin();
  },
  methods: {

    Toggle() {
      var temp = document.getElementById("typepass");
      if (temp.type === "password") {
        temp.type = "text";
        this.eye = true;
        this.eyeslash = false;
      } else {
        temp.type = "password";
        this.eye = false;
        this.eyeslash = true;
      }
    },
    // onVerify(response) {
    //   if (response == "") {
    //     this.$alert('Please verify that you are a Human.', "LogIn", "error");
    //   } else {
    //     this.$alert("Thank You", "LogIn", "success");
    //     this.form.robot = true;
    //   }
    // },

    async ssologin() {
      this.isSSOLoading = true;
      await axios.post(apiUrl.api_url + 'loginwithsso', {
          'token': this.tokenid
        })
        .then((response) => {
          if (response.data.code == 200) {
            let permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.data.access), "Key");
            let usersEncrupt = CryptoJS.AES.encrypt(JSON.stringify(response.data.data), "Key");
            window.localStorage.setItem('cargoAutoaccesspermissiondata', permissionEncrypt);
            window.localStorage.setItem('cargoAutoaccessuserdata', usersEncrupt);
            window.localStorage.setItem('userToken', response.data.data.userToken);
            window.localStorage.setItem('isLoggedIn', true);
            permissionEncrypt = window.localStorage.getItem('cargoAutoaccesspermissiondata');
            let permissiondatabytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
            let permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);
            let permissiondata = JSON.parse(permissiondataplaintext);
            let huddata = response.data.data.hubID;
            let url = permissiondata[0].url;
            this.getHubName(huddata, url);
            this.isSSOLoading = false;
          } else {
            this.isSSOLoading = false;
            this.tokenid = '';
            this.$router.push('/login');
            this.$alert("Login failed. " + response.data.error + ".", "", "error");
          }
        }, error => {
          this.isSSOLoading = false;
          this.tokenid = '';
          this.$router.push('/login');
          this.$alert("Login failed.", "", "error");
          console.error('exception is:::::::::', error)
        });
    },

    checklogin() {
      try{
      this.isLoading = true;
      this.issumbit = true;
      const decoded = VueJwtDecode.decode(window.localStorage.getItem('userToken'));
       console.log("decoded", decoded.aud);
       if(decoded.aud.includes(apiUrl.authclientidapi)){
      axios.post(apiUrl.api_url + 'authorization', {
          'appname': 'b2bexpress'
        })
        .then((response) => {
          if (response.data.code == 200) {
            let permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.data.access), "Key");
            let usersEncrupt = CryptoJS.AES.encrypt(JSON.stringify(response.data.data), "Key");
            window.localStorage.setItem('cargoAutoaccesspermissiondata', permissionEncrypt);
            window.localStorage.setItem('cargoAutoaccessuserdata', usersEncrupt);
            window.localStorage.setItem('userToken', response.data.data.userToken);
            window.localStorage.setItem('isLoggedIn', true);
            permissionEncrypt = window.localStorage.getItem('cargoAutoaccesspermissiondata');
            let permissiondatabytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
            let permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);
            let permissiondata = JSON.parse(permissiondataplaintext);
            var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
            var userBytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
            var userPlaintext = userBytes.toString(CryptoJS.enc.Utf8);
            var userdetail = JSON.parse(userPlaintext);
            // var path = to.path.toString()
            var userid = parseInt(userdetail.userid);
            var username = userdetail.username;
            var project = userdetail.project;
            let InputPayload = {
              "projectname": project,
              "type": "web",
              "userid":userid,
              "username":username,
              "routeurl":'/login',
              "meta" : {
                "event" : "Login"
              }
            };
            let huddata = response.data.data.hubID;
            let url = "dashboard";
            this.getHubName(huddata, url);
            this.getTraceIP(InputPayload);
          } else if(response.data.code == 302){
            console.log("Error code - L148");
            // this.$alert("Something went wrong.", "", "error");
            this.loginfailed=true;
            this.loginfailedmsg="Something went wrong.";
            // window.setTimeout(function(){
            //   keycloak.logoutWithoutTokenId()
            // }, 5000);
            // window.location.href= response.data.redirecturl;
          }else {
            // this.$alert("Login failed. " + response.data.error + ".", "", "error");
            console.log("Error code - L156");
            // this.$alert("Something went wrong.", "", "error");
            this.loginfailed=true;
            this.loginfailedmsg="Something went wrong.";
            // window.setTimeout(function(){
            //   keycloak.logoutWithoutTokenId()
            // }, 5000);
            this.isLoading = false;
            this.issumbit = false;
          }
        }, error => {
          console.log("Error code - L165");
          // this.$alert("Something went wrong.", "", "error");
          this.loginfailed=true;
          this.loginfailedmsg="Something went wrong.";
            // window.setTimeout(function(){
            //   keycloak.logoutWithoutTokenId()
            // }, 5000);
          this.isLoading = false;
          this.issumbit = false;
          console.error('exception is:::::::::', error)
        });
      } else {
        console.log("Error code - L175");
        this.loginfailed=true;
        this.loginfailedmsg="You don't have access to B2B APP.";
        // this.$alert("You don't have access to B2B APP. Please contact support.", "", "error");
        // window.setTimeout(function(){
        //   keycloak.logoutWithoutTokenId()
        // }, 5000);
      }
    } catch(error) {
      console.log("Error code - L183");
        // this.$alert("Something went wrong.", "", "error");
        this.loginfailed=true;
        this.loginfailedmsg="Something went wrong.";
        // window.setTimeout(function(){
        //   keycloak.logoutWithoutTokenId()
        // }, 5000);
    }
    },
    getHubName(huddata, url) {
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'external/gethubdetail',
          'data': {
            "HubID": huddata
          },
        })
        .then(async result => {
          this.issumbit = '';
          if (result.data.code == 200) {
            let hubName = result.data.data[0].HubName;
            let getuserdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
            let getbytes = CryptoJS.AES.decrypt(getuserdetailEncrypt.toString(), 'Key');
            let getplaintext = getbytes.toString(CryptoJS.enc.Utf8);
            let userdetail = JSON.parse(getplaintext);
            userdetail.currentHubName = hubName;
            let setusersEncrupt = CryptoJS.AES.encrypt(JSON.stringify(userdetail), "Key");
            window.localStorage.setItem('cargoAutoaccessuserdata', setusersEncrupt);
            this.isLoading = false;
            this.$router.push(url);
          } else {
            this.isLoading = false;
            this.$alert("Login failed. Unable to fetch Hub list.", "", "error");
          }
        }, error => {
          this.isLoading = false;
          this.$alert("Login failed. Unable to fetch Hub list.", "", "error");
          console.error('exception is:::::::::', error);
        })
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if (this.form.robot == false) {
          //   this.$alert('Please verify that you are a Human.', "LogIn", "error");
          //
          // } else {
            this.checklogin();
          // }

        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    async getTraceIP(InputPayload){
      const axiosInstance = axios.create();
      try{
        let result = axiosInstance({
        	method: 'POST',
        	'url': apiUrl.iptracker_url + 'UserTracker',
        	'data': InputPayload,
        })
        return result;
      }
      catch (err) {
        throw new Error(err);
      }
    },
    logout() {
      keycloak.logoutWithoutTokenId();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/login/login.component.js